import { PaymentsPage } from "../../components/PaymentList";

export default function DriverPayments() {
  return <PaymentsPage isAdmin={false} />;
}
